import { Button, Dialog, Typography } from '@mui/material';
import { useRouter } from 'next/router';
// Components
import MetaMaskButton from '@/components/ExternalWallets/MetaMask/MetaMaskButton';
import { CopyToClipboard } from '@/common/index';
// Hooks & Utils
import { useIsMobile } from '@/hooks/useIsMobile';
// Styles & Assets
import { WalletIcon } from '@/icons/iconComponents/sideNav';
import styles from './wallet-modals.module.css';

export default function WalletModal({
  handleExternalPayment,
  resetMetamask,
  setShowDownloadModal,
  setConnectionPending,
}) {
  const router = useRouter();
  const isMobile = useIsMobile(820);

  const handleClose = () => {
    setConnectionPending(false);
    setShowDownloadModal(false);
  };

  if (isMobile) {
    return (
      <Dialog open onClose={handleClose}>
        <div className={styles.modal}>
          <Typography variant="h3" className={styles.modalHeading}>
            MetaMask Checkout
          </Typography>
          <Typography variant="body1Dark" className={styles.modalText}>
            To complete the checkout process using your MetaMask wallet on a mobile
            device, MetaMask requires you to do so using their in-app browser application.
            Steps to pay with MetaMask through the browser application include:
          </Typography>
          <ol className={styles.list}>
            <li>Download and open up MetaMask</li>
            <li>Tap on the browser tab at the bottom of the page</li>
            <li>Enter the link provided below into the url search field</li>
            <li>Restart checkout process</li>
          </ol>
          <div className={styles.modalCopy}>
            <CopyToClipboard copyText={`${window.location.href}`} />
          </div>
          <Typography variant="body1Dark" className={styles.modalText}>
            Alternatively, choose the “Pay with External” wallet option to continue with
            checkout process and still be able to use your MetaMask wallet.
          </Typography>
          <div className={styles.modalButtonRow}>
            <Button
              type="button"
              variant="outlined"
              size="medium"
              onClick={handleExternalPayment}
              data-core-qa="fundWalletButtonExternal"
              fullWidth
            >
              <span className={styles.walletButton}>
                <WalletIcon className={styles.walletIconMobile} />
                Pay with External Wallet
              </span>
            </Button>
            <a href="https://metamask.io/download/" target="_blank" rel="noreferrer">
              <MetaMaskButton qaDataTag="fundWalletButtonDownload">
                Download MetaMask App
              </MetaMaskButton>
            </a>
          </div>
        </div>
      </Dialog>
    );
  }

  return (
    <Dialog open onClose={handleClose}>
      <div className={styles.modal}>
        <Typography variant="h3" className={styles.modalHeading}>
          MetaMask Installation
        </Typography>
        <Typography variant="body1" className={styles.modalText}>
          Looks like you don’t have MetaMask installed on your browser. Click the button
          below to download. Once you have finished installing MetaMask, please click done
          to refresh the page.
        </Typography>
        <div className={styles.modalButtonRow}>
          <a href="https://metamask.io/download/" target="_blank" rel="noreferrer">
            <Button
              variant="contained"
              size="large"
              fullWidth
              data-core-qa="fundWalletButtonDownload"
            >
              Download MetaMask Extension
            </Button>
          </a>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            data-core-qa="fundWalletButtonRefresh"
            onClick={() => {
              resetMetamask();
              router.reload();
            }}
          >
            Done
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
